<template>
  <!-- <div style="display: flex; flex-direction: column; gap: 10px"> -->
  <div class="m-card">
    <div class="header-surface-graph">
      <h4 class="text-w text-gray">
        <slot name="title">Surface Temperature Graph</slot>
      </h4>
      <vs-spacer></vs-spacer>
      <vs-select v-model="select1" width="120px" @change="selectData">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in options1"
        />
      </vs-select>
    </div>
    <LineChart
      :height="250"
      :chartdata="chartData"
      :options="optionsChart"
      :areaColors="['#007bff']"
      :heightChart="200"
    />
    <div class="bottom-surface-graph">
      <div class="legend-box">
        <div class="legend" :style="'background-color: ' + color + ';'"></div>
        Surface Temperature
      </div>
      <div class="bottom-right-surface-graph">
        <div class="box-chart">
          <p class="avg">avg</p>
          <p>{{ avg.toFixed(2) }}°C</p>
        </div>
        <div class="box-chart">
          <p class="min">min</p>
          <p>{{ min.toFixed(2) }}°C</p>
        </div>
        <div class="box-chart">
          <p class="max">max</p>
          <p>{{ max.toFixed(2) }}°C</p>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: {
    LineChart,
  },
  props: {
    color: String,
    dataTemp: Object,
  },
  data() {
    return {
      options1: ["Day", "Month", "Year"],
      select1: "Day",
      chartData: {
        datasets: [
          {
            data: [],
            label: "Temperature ( °C )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: this.color,
            //     backgroundColor:  this.gradient,
          },
        ],
        labels: [],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                step: 1,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                // labelString: this.chartdata.tooltip_label,
              },
            },
          ],
          // xAxes: [
          //   {
          //     // ticks: {
          //     //   // beginAtZero: true,
          //     //   fontColor: "#ffffff",
          //     // },
          //     // scaleLabel: {
          //     //   // display: true,
          //     //   // labelString: "Timestamp",
          //     // },
          //     type: 'time',
          //   },
          // ],
        },
      },
      max: 0,
      min: 0,
      avg: 0,
    };
  },
  mounted() {
    this.selectData();
  },
  methods: {
    selectData() {
      console.log(this.dataTemp[0].surface_temperature_graph);
      let labels = [];
      let data = [];
      let max = 0;
      let min = 100;
      let sum = 0;
      for (
        let i = 0;
        i <
        this.dataTemp[0].surface_temperature_graph[this.select1.toLowerCase()]
          .length;
        i++
      ) {
        const el =
          this.dataTemp[0].surface_temperature_graph[
            this.select1.toLowerCase()
          ][i];
        labels.push(el.date);
        data.push(el.temp);
        sum += Number(el.temp);
        max = max > Number(el.temp) ? max : Number(el.temp);
        min = min < Number(el.temp) ? min : Number(el.temp);
      }
      this.max = max;
      this.min = min;
      this.avg =
        sum /
        this.dataTemp[0].surface_temperature_graph[this.select1.toLowerCase()]
          .length;
      this.$emit("max-min", [this.max, this.min]);

      // console.log(labels, data);
      this.chartData.labels = labels;
      this.chartData.datasets[0].data = data;
    },
  },
  watch: {
    'dataTemp':{ // watch it
      handler(newValue, oldValue) {
      console.log('redraw chart dataTemp');
      // console.log(newValue, oldValue);
      this.selectData()
      },
      deep: true
      }
  },
};
</script>

<style lang="scss" scoped>
.m-card {
  color: var(--text-color-2);
}
.text-w {
  font-weight: 700;
}
.header-surface-graph {
  display: flex;
  align-items: center;
}
.bottom-surface-graph {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottom-right-surface-graph {
  display: flex;
  align-items: center;
  gap: 10px;
}
.legend-box {
  display: flex;
  align-items: center;
  gap: 5px;
}
.legend {
  width: 30px;
  height: 15px;
  background-color: #f707ff;
  border-radius: 5px;
}
.box-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
  }
}
.avg {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #ffa807;
}
.min {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #f707ff;
}
.max {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #8f07ff;
}
</style>